import React from 'react';
import { Link } from 'react-router-dom';

const PosturalStudies: React.FC = () => {
  return (
    <section className="py-8 md:py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div>
            <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/3]">
              <img
                src="/etude-posturale-podium.png"
                alt="Etudes posturales"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column - Text Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Etudes posturales
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Notre étude posturale vise à optimiser votre position sur le vélo pour améliorer performance, confort et prévention des blessures.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Grâce à une analyse précise de votre morphologie, de votre mobilité et de vos objectifs, nous ajustons chaque point de contact.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-8">
              Résultat : une position plus efficace, plus confortable, et parfaitement adaptée à votre pratique, du loisir à la compétition.
            </p>

            <Link 
              to="/etude-posturale"
              className="inline-block bg-black text-white px-8 py-3 rounded-lg hover:bg-gray-800 transition-colors duration-300 font-medium"
            >
              Je prends rendez-vous
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PosturalStudies;
